// source: sceneview/protos/scene_view_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_geometry_pb = require('../../core/protos/geometry_pb.js');
goog.object.extend(proto, core_protos_geometry_pb);
var core_protos_model_entity_pb = require('../../core/protos/model_entity_pb.js');
goog.object.extend(proto, core_protos_model_entity_pb);
var core_protos_model_views_pb = require('../../core/protos/model_views_pb.js');
goog.object.extend(proto, core_protos_model_views_pb);
var core_protos_measurement_pb = require('../../core/protos/measurement_pb.js');
goog.object.extend(proto, core_protos_measurement_pb);
var core_protos_paging_pb = require('../../core/protos/paging_pb.js');
goog.object.extend(proto, core_protos_paging_pb);
var core_protos_scene_annotations_pb = require('../../core/protos/scene_annotations_pb.js');
goog.object.extend(proto, core_protos_scene_annotations_pb);
var core_protos_scene_canvas_pb = require('../../core/protos/scene_canvas_pb.js');
goog.object.extend(proto, core_protos_scene_canvas_pb);
var core_protos_uuid_pb = require('../../core/protos/uuid_pb.js');
goog.object.extend(proto, core_protos_uuid_pb);
var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js');
goog.object.extend(proto, google_protobuf_field_mask_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var sceneview_protos_domain_pb = require('../../sceneview/protos/domain_pb.js');
goog.object.extend(proto, sceneview_protos_domain_pb);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.LookupByCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.ItemIdCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.MeasureEntity', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.MeasureRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.MeasureResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.MeasureRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.MeasureRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.MeasureEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.displayName = 'proto.vertexvis.protobuf.sceneview.v1.MeasureEntity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.MeasureResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.MeasureResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.displayName = 'proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.displayName = 'proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.oneofGroups_ = [[2]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.ItemIdCase = {
  ITEM_ID_NOT_SET: 0,
  SCENE_ITEM_ID: 2
};

/**
 * @return {proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.ItemIdCase}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.getItemIdCase = function() {
  return /** @type {proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.ItemIdCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    viewId: (f = msg.getViewId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    sceneItemId: (f = msg.getSceneItemId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    additionalFields: (f = msg.getAdditionalFields()) && google_protobuf_field_mask_pb.FieldMask.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest;
  return proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setViewId(value);
      break;
    case 2:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setSceneItemId(value);
      break;
    case 3:
      var value = new google_protobuf_field_mask_pb.FieldMask;
      reader.readMessage(value,google_protobuf_field_mask_pb.FieldMask.deserializeBinaryFromReader);
      msg.setAdditionalFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getSceneItemId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getAdditionalFields();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_field_mask_pb.FieldMask.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid2l view_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.getViewId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.setViewId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.clearViewId = function() {
  return this.setViewId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.hasViewId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Uuid2l scene_item_id = 2;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.getSceneItemId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.setSceneItemId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.clearSceneItemId = function() {
  return this.setSceneItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.hasSceneItemId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.FieldMask additional_fields = 3;
 * @return {?proto.google.protobuf.FieldMask}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.getAdditionalFields = function() {
  return /** @type{?proto.google.protobuf.FieldMask} */ (
    jspb.Message.getWrapperField(this, google_protobuf_field_mask_pb.FieldMask, 3));
};


/**
 * @param {?proto.google.protobuf.FieldMask|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.setAdditionalFields = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.clearAdditionalFields = function() {
  return this.setAdditionalFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemRequest.prototype.hasAdditionalFields = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && sceneview_protos_domain_pb.SceneViewItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse;
  return proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new sceneview_protos_domain_pb.SceneViewItem;
      reader.readMessage(value,sceneview_protos_domain_pb.SceneViewItem.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      sceneview_protos_domain_pb.SceneViewItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional SceneViewItem item = 1;
 * @return {?proto.vertexvis.protobuf.sceneview.v1.SceneViewItem}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.prototype.getItem = function() {
  return /** @type{?proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} */ (
    jspb.Message.getWrapperField(this, sceneview_protos_domain_pb.SceneViewItem, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.sceneview.v1.SceneViewItem|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.GetSceneViewItemResponse.prototype.hasItem = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sceneAnnotationSetId: (f = msg.getSceneAnnotationSetId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest;
  return proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setSceneAnnotationSetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSceneAnnotationSetId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid scene_annotation_set_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.prototype.getSceneAnnotationSetId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.prototype.setSceneAnnotationSetId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.prototype.clearSceneAnnotationSetId = function() {
  return this.setSceneAnnotationSetId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetRequest.prototype.hasSceneAnnotationSetId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse;
  return proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.CreateSceneViewAnnotationSetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sceneAnnotationSetId: (f = msg.getSceneAnnotationSetId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest;
  return proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setSceneAnnotationSetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSceneAnnotationSetId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid scene_annotation_set_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.prototype.getSceneAnnotationSetId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.prototype.setSceneAnnotationSetId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.prototype.clearSceneAnnotationSetId = function() {
  return this.setSceneAnnotationSetId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetRequest.prototype.hasSceneAnnotationSetId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse;
  return proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.DeleteSceneViewAnnotationSetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: (f = msg.getItemId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f),
    page: (f = msg.getPage()) && core_protos_paging_pb.Pager.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest;
  return proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setItemId(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Pager;
      reader.readMessage(value,core_protos_paging_pb.Pager.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Pager.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid item_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.getItemId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.setItemId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.clearItemId = function() {
  return this.setItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.hasItemId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Pager page = 2;
 * @return {?proto.vertexvis.protobuf.core.Pager}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.getPage = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Pager} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Pager, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Pager|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    representationsList: jspb.Message.toObjectList(msg.getRepresentationsList(),
    sceneview_protos_domain_pb.ItemRepresentation.toObject, includeInstance),
    systemRepresentationsList: jspb.Message.toObjectList(msg.getSystemRepresentationsList(),
    sceneview_protos_domain_pb.ItemRepresentation.toObject, includeInstance),
    nextPageCursor: (f = msg.getNextPageCursor()) && core_protos_paging_pb.Cursor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse;
  return proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new sceneview_protos_domain_pb.ItemRepresentation;
      reader.readMessage(value,sceneview_protos_domain_pb.ItemRepresentation.deserializeBinaryFromReader);
      msg.addRepresentations(value);
      break;
    case 2:
      var value = new sceneview_protos_domain_pb.ItemRepresentation;
      reader.readMessage(value,sceneview_protos_domain_pb.ItemRepresentation.deserializeBinaryFromReader);
      msg.addSystemRepresentations(value);
      break;
    case 3:
      var value = new core_protos_paging_pb.Cursor;
      reader.readMessage(value,core_protos_paging_pb.Cursor.deserializeBinaryFromReader);
      msg.setNextPageCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRepresentationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      sceneview_protos_domain_pb.ItemRepresentation.serializeBinaryToWriter
    );
  }
  f = message.getSystemRepresentationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      sceneview_protos_domain_pb.ItemRepresentation.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_paging_pb.Cursor.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ItemRepresentation representations = 1;
 * @return {!Array<!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation>}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.getRepresentationsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation>} */ (
    jspb.Message.getRepeatedWrapperField(this, sceneview_protos_domain_pb.ItemRepresentation, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation>} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.setRepresentationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.addRepresentations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.clearRepresentationsList = function() {
  return this.setRepresentationsList([]);
};


/**
 * repeated ItemRepresentation system_representations = 2;
 * @return {!Array<!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation>}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.getSystemRepresentationsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation>} */ (
    jspb.Message.getRepeatedWrapperField(this, sceneview_protos_domain_pb.ItemRepresentation, 2));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation>} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.setSystemRepresentationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.addSystemRepresentations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.clearSystemRepresentationsList = function() {
  return this.setSystemRepresentationsList([]);
};


/**
 * optional vertexvis.protobuf.core.Cursor next_page_cursor = 3;
 * @return {?proto.vertexvis.protobuf.core.Cursor}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.getNextPageCursor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Cursor} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Cursor, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Cursor|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.clearNextPageCursor = function() {
  return this.setNextPageCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemRepresentationsResponse.prototype.hasNextPageCursor = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: (f = msg.getItemId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    page: (f = msg.getPage()) && core_protos_paging_pb.Pager.toObject(includeInstance, f),
    hasAnnotations: (f = msg.getHasAnnotations()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest;
  return proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setItemId(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Pager;
      reader.readMessage(value,core_protos_paging_pb.Pager.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setHasAnnotations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Pager.serializeBinaryToWriter
    );
  }
  f = message.getHasAnnotations();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid2l item_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.getItemId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.setItemId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.clearItemId = function() {
  return this.setItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.hasItemId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Pager page = 2;
 * @return {?proto.vertexvis.protobuf.core.Pager}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.getPage = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Pager} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Pager, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Pager|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue has_annotations = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.getHasAnnotations = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.setHasAnnotations = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.clearHasAnnotations = function() {
  return this.setHasAnnotations(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsRequest.prototype.hasHasAnnotations = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelViewsList: jspb.Message.toObjectList(msg.getModelViewsList(),
    core_protos_model_views_pb.ModelView.toObject, includeInstance),
    nextPageCursor: (f = msg.getNextPageCursor()) && core_protos_paging_pb.Cursor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse;
  return proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_model_views_pb.ModelView;
      reader.readMessage(value,core_protos_model_views_pb.ModelView.deserializeBinaryFromReader);
      msg.addModelViews(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Cursor;
      reader.readMessage(value,core_protos_paging_pb.Cursor.deserializeBinaryFromReader);
      msg.setNextPageCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelViewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      core_protos_model_views_pb.ModelView.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Cursor.serializeBinaryToWriter
    );
  }
};


/**
 * repeated vertexvis.protobuf.core.ModelView model_views = 1;
 * @return {!Array<!proto.vertexvis.protobuf.core.ModelView>}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.getModelViewsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.core.ModelView>} */ (
    jspb.Message.getRepeatedWrapperField(this, core_protos_model_views_pb.ModelView, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.core.ModelView>} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.setModelViewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.core.ModelView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.core.ModelView}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.addModelViews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.core.ModelView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.clearModelViewsList = function() {
  return this.setModelViewsList([]);
};


/**
 * optional vertexvis.protobuf.core.Cursor next_page_cursor = 2;
 * @return {?proto.vertexvis.protobuf.core.Cursor}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.getNextPageCursor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Cursor} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Cursor, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Cursor|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.clearNextPageCursor = function() {
  return this.setNextPageCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListItemModelViewsResponse.prototype.hasNextPageCursor = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelViewId: (f = msg.getModelViewId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    page: (f = msg.getPage()) && core_protos_paging_pb.Pager.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest;
  return proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setModelViewId(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Pager;
      reader.readMessage(value,core_protos_paging_pb.Pager.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelViewId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Pager.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid2l model_view_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.getModelViewId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.setModelViewId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.clearModelViewId = function() {
  return this.setModelViewId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.hasModelViewId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Pager page = 2;
 * @return {?proto.vertexvis.protobuf.core.Pager}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.getPage = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Pager} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Pager, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Pager|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    annotationsList: jspb.Message.toObjectList(msg.getAnnotationsList(),
    core_protos_model_views_pb.PmiAnnotation.toObject, includeInstance),
    nextPageCursor: (f = msg.getNextPageCursor()) && core_protos_paging_pb.Cursor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse;
  return proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_model_views_pb.PmiAnnotation;
      reader.readMessage(value,core_protos_model_views_pb.PmiAnnotation.deserializeBinaryFromReader);
      msg.addAnnotations(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Cursor;
      reader.readMessage(value,core_protos_paging_pb.Cursor.deserializeBinaryFromReader);
      msg.setNextPageCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnnotationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      core_protos_model_views_pb.PmiAnnotation.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Cursor.serializeBinaryToWriter
    );
  }
};


/**
 * repeated vertexvis.protobuf.core.PmiAnnotation annotations = 1;
 * @return {!Array<!proto.vertexvis.protobuf.core.PmiAnnotation>}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.getAnnotationsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.core.PmiAnnotation>} */ (
    jspb.Message.getRepeatedWrapperField(this, core_protos_model_views_pb.PmiAnnotation, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.core.PmiAnnotation>} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.setAnnotationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.core.PmiAnnotation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.core.PmiAnnotation}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.addAnnotations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.core.PmiAnnotation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.clearAnnotationsList = function() {
  return this.setAnnotationsList([]);
};


/**
 * optional vertexvis.protobuf.core.Cursor next_page_cursor = 2;
 * @return {?proto.vertexvis.protobuf.core.Cursor}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.getNextPageCursor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Cursor} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Cursor, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Cursor|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.clearNextPageCursor = function() {
  return this.setNextPageCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListPmiAnnotationsResponse.prototype.hasNextPageCursor = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: (f = msg.getPage()) && core_protos_paging_pb.Pager.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest;
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_paging_pb.Pager;
      reader.readMessage(value,core_protos_paging_pb.Pager.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_paging_pb.Pager.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Pager page = 1;
 * @return {?proto.vertexvis.protobuf.core.Pager}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.prototype.getPage = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Pager} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Pager, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Pager|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sceneAnnotationSetsList: jspb.Message.toObjectList(msg.getSceneAnnotationSetsList(),
    core_protos_scene_annotations_pb.SceneAnnotationSet.toObject, includeInstance),
    nextCursor: (f = msg.getNextCursor()) && core_protos_paging_pb.Cursor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse;
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_scene_annotations_pb.SceneAnnotationSet;
      reader.readMessage(value,core_protos_scene_annotations_pb.SceneAnnotationSet.deserializeBinaryFromReader);
      msg.addSceneAnnotationSets(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Cursor;
      reader.readMessage(value,core_protos_paging_pb.Cursor.deserializeBinaryFromReader);
      msg.setNextCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSceneAnnotationSetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      core_protos_scene_annotations_pb.SceneAnnotationSet.serializeBinaryToWriter
    );
  }
  f = message.getNextCursor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Cursor.serializeBinaryToWriter
    );
  }
};


/**
 * repeated vertexvis.protobuf.core.SceneAnnotationSet scene_annotation_sets = 1;
 * @return {!Array<!proto.vertexvis.protobuf.core.SceneAnnotationSet>}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.getSceneAnnotationSetsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.core.SceneAnnotationSet>} */ (
    jspb.Message.getRepeatedWrapperField(this, core_protos_scene_annotations_pb.SceneAnnotationSet, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.core.SceneAnnotationSet>} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.setSceneAnnotationSetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotationSet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotationSet}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.addSceneAnnotationSets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.core.SceneAnnotationSet, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.clearSceneAnnotationSetsList = function() {
  return this.setSceneAnnotationSetsList([]);
};


/**
 * optional vertexvis.protobuf.core.Cursor next_cursor = 2;
 * @return {?proto.vertexvis.protobuf.core.Cursor}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.getNextCursor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Cursor} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Cursor, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Cursor|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.setNextCursor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.clearNextCursor = function() {
  return this.setNextCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneViewAnnotationSetsResponse.prototype.hasNextCursor = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sceneAnnotationSetId: (f = msg.getSceneAnnotationSetId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    page: (f = msg.getPage()) && core_protos_paging_pb.Pager.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest;
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setSceneAnnotationSetId(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Pager;
      reader.readMessage(value,core_protos_paging_pb.Pager.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSceneAnnotationSetId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Pager.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid2l scene_annotation_set_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.getSceneAnnotationSetId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.setSceneAnnotationSetId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.clearSceneAnnotationSetId = function() {
  return this.setSceneAnnotationSetId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.hasSceneAnnotationSetId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Pager page = 2;
 * @return {?proto.vertexvis.protobuf.core.Pager}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.getPage = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Pager} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Pager, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Pager|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sceneAnnotationsList: jspb.Message.toObjectList(msg.getSceneAnnotationsList(),
    core_protos_scene_annotations_pb.SceneAnnotation.toObject, includeInstance),
    nextCursor: (f = msg.getNextCursor()) && core_protos_paging_pb.Cursor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse;
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_scene_annotations_pb.SceneAnnotation;
      reader.readMessage(value,core_protos_scene_annotations_pb.SceneAnnotation.deserializeBinaryFromReader);
      msg.addSceneAnnotations(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Cursor;
      reader.readMessage(value,core_protos_paging_pb.Cursor.deserializeBinaryFromReader);
      msg.setNextCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSceneAnnotationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      core_protos_scene_annotations_pb.SceneAnnotation.serializeBinaryToWriter
    );
  }
  f = message.getNextCursor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Cursor.serializeBinaryToWriter
    );
  }
};


/**
 * repeated vertexvis.protobuf.core.SceneAnnotation scene_annotations = 1;
 * @return {!Array<!proto.vertexvis.protobuf.core.SceneAnnotation>}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.getSceneAnnotationsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.core.SceneAnnotation>} */ (
    jspb.Message.getRepeatedWrapperField(this, core_protos_scene_annotations_pb.SceneAnnotation, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.core.SceneAnnotation>} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.setSceneAnnotationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.core.SceneAnnotation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.core.SceneAnnotation}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.addSceneAnnotations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.core.SceneAnnotation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.clearSceneAnnotationsList = function() {
  return this.setSceneAnnotationsList([]);
};


/**
 * optional vertexvis.protobuf.core.Cursor next_cursor = 2;
 * @return {?proto.vertexvis.protobuf.core.Cursor}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.getNextCursor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Cursor} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Cursor, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Cursor|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.setNextCursor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.clearNextCursor = function() {
  return this.setNextCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneAnnotationsResponse.prototype.hasNextCursor = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    entitiesList: jspb.Message.toObjectList(msg.getEntitiesList(),
    proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.MeasureRequest;
  return proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.sceneview.v1.MeasureEntity;
      reader.readMessage(value,proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.deserializeBinaryFromReader);
      msg.addEntities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MeasureEntity entities = 1;
 * @return {!Array<!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity>}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.prototype.getEntitiesList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.sceneview.v1.MeasureEntity, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity>} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.prototype.setEntitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.prototype.addEntities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.sceneview.v1.MeasureEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureRequest.prototype.clearEntitiesList = function() {
  return this.setEntitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelEntity: (f = msg.getModelEntity()) && core_protos_model_entity_pb.ModelEntity.toObject(includeInstance, f),
    point: (f = msg.getPoint()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.MeasureEntity;
  return proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_model_entity_pb.ModelEntity;
      reader.readMessage(value,core_protos_model_entity_pb.ModelEntity.deserializeBinaryFromReader);
      msg.setModelEntity(value);
      break;
    case 2:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelEntity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_model_entity_pb.ModelEntity.serializeBinaryToWriter
    );
  }
  f = message.getPoint();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.ModelEntity model_entity = 1;
 * @return {?proto.vertexvis.protobuf.core.ModelEntity}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.getModelEntity = function() {
  return /** @type{?proto.vertexvis.protobuf.core.ModelEntity} */ (
    jspb.Message.getWrapperField(this, core_protos_model_entity_pb.ModelEntity, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.ModelEntity|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.setModelEntity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.clearModelEntity = function() {
  return this.setModelEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.hasModelEntity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Vector3f point = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.getPoint = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.setPoint = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureEntity} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.clearPoint = function() {
  return this.setPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureEntity.prototype.hasPoint = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    outcome: (f = msg.getOutcome()) && core_protos_measurement_pb.MeasurementOutcome.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.MeasureResponse;
  return proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_measurement_pb.MeasurementOutcome;
      reader.readMessage(value,core_protos_measurement_pb.MeasurementOutcome.deserializeBinaryFromReader);
      msg.setOutcome(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.MeasureResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOutcome();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_measurement_pb.MeasurementOutcome.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.MeasurementOutcome outcome = 1;
 * @return {?proto.vertexvis.protobuf.core.MeasurementOutcome}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.prototype.getOutcome = function() {
  return /** @type{?proto.vertexvis.protobuf.core.MeasurementOutcome} */ (
    jspb.Message.getWrapperField(this, core_protos_measurement_pb.MeasurementOutcome, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.MeasurementOutcome|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.prototype.setOutcome = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.MeasureResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.prototype.clearOutcome = function() {
  return this.setOutcome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.MeasureResponse.prototype.hasOutcome = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    updatesList: jspb.Message.toObjectList(msg.getUpdatesList(),
    proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest;
  return proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate;
      reader.readMessage(value,proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.deserializeBinaryFromReader);
      msg.addUpdates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ModelEntityUpdate updates = 1;
 * @return {!Array<!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate>}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.prototype.getUpdatesList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate>} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.prototype.setUpdatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.prototype.addUpdates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesRequest.prototype.clearUpdatesList = function() {
  return this.setUpdatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelEntity: (f = msg.getModelEntity()) && core_protos_model_entity_pb.ModelEntity.toObject(includeInstance, f),
    highlight: (f = msg.getHighlight()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate}
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate;
  return proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate}
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_model_entity_pb.ModelEntity;
      reader.readMessage(value,core_protos_model_entity_pb.ModelEntity.deserializeBinaryFromReader);
      msg.setModelEntity(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setHighlight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelEntity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_model_entity_pb.ModelEntity.serializeBinaryToWriter
    );
  }
  f = message.getHighlight();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.ModelEntity model_entity = 1;
 * @return {?proto.vertexvis.protobuf.core.ModelEntity}
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.getModelEntity = function() {
  return /** @type{?proto.vertexvis.protobuf.core.ModelEntity} */ (
    jspb.Message.getWrapperField(this, core_protos_model_entity_pb.ModelEntity, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.ModelEntity|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.setModelEntity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.clearModelEntity = function() {
  return this.setModelEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.hasModelEntity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.BoolValue highlight = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.getHighlight = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.setHighlight = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.clearHighlight = function() {
  return this.setHighlight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ModelEntityUpdate.prototype.hasHighlight = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse;
  return proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.UpdateModelEntitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: (f = msg.getItemId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    pager: (f = msg.getPager()) && core_protos_paging_pb.Pager.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest;
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setItemId(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Pager;
      reader.readMessage(value,core_protos_paging_pb.Pager.deserializeBinaryFromReader);
      msg.setPager(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getPager();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Pager.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid2l item_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.getItemId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.setItemId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.clearItemId = function() {
  return this.setItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.hasItemId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Pager pager = 2;
 * @return {?proto.vertexvis.protobuf.core.Pager}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.getPager = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Pager} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Pager, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Pager|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.setPager = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.clearPager = function() {
  return this.setPager(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataRequest.prototype.hasPager = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    sceneview_protos_domain_pb.PropertyEntry.toObject, includeInstance),
    cursor: (f = msg.getCursor()) && core_protos_paging_pb.Cursor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse;
  return proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new sceneview_protos_domain_pb.PropertyEntry;
      reader.readMessage(value,sceneview_protos_domain_pb.PropertyEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.Cursor;
      reader.readMessage(value,core_protos_paging_pb.Cursor.deserializeBinaryFromReader);
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      sceneview_protos_domain_pb.PropertyEntry.serializeBinaryToWriter
    );
  }
  f = message.getCursor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.Cursor.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PropertyEntry entries = 1;
 * @return {!Array<!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry>}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, sceneview_protos_domain_pb.PropertyEntry, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry>} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.sceneview.v1.PropertyEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};


/**
 * optional vertexvis.protobuf.core.Cursor cursor = 2;
 * @return {?proto.vertexvis.protobuf.core.Cursor}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.getCursor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Cursor} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.Cursor, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Cursor|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.setCursor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.clearCursor = function() {
  return this.setCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ListSceneItemMetadataResponse.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.LookupByCase = {
  LOOKUP_BY_NOT_SET: 0,
  CANVAS_ID: 1,
  SCENE_VIEW_STATE_ID: 2
};

/**
 * @return {proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.LookupByCase}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.getLookupByCase = function() {
  return /** @type {proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.LookupByCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    canvasId: (f = msg.getCanvasId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    sceneViewStateId: (f = msg.getSceneViewStateId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest;
  return proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setCanvasId(value);
      break;
    case 2:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setSceneViewStateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanvasId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getSceneViewStateId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid2l canvas_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.getCanvasId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.setCanvasId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.clearCanvasId = function() {
  return this.setCanvasId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.hasCanvasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Uuid2l scene_view_state_id = 2;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.getSceneViewStateId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.setSceneViewStateId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.clearSceneViewStateId = function() {
  return this.setSceneViewStateId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasRequest.prototype.hasSceneViewStateId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    canvas: (f = msg.getCanvas()) && core_protos_scene_canvas_pb.Canvas.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse;
  return proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_scene_canvas_pb.Canvas;
      reader.readMessage(value,core_protos_scene_canvas_pb.Canvas.deserializeBinaryFromReader);
      msg.setCanvas(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanvas();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_scene_canvas_pb.Canvas.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Canvas canvas = 1;
 * @return {?proto.vertexvis.protobuf.core.Canvas}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.prototype.getCanvas = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Canvas} */ (
    jspb.Message.getWrapperField(this, core_protos_scene_canvas_pb.Canvas, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Canvas|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.prototype.setCanvas = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.prototype.clearCanvas = function() {
  return this.setCanvas(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.GetCanvasResponse.prototype.hasCanvas = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.vertexvis.protobuf.sceneview.v1);
